<template>
  <div v-if="registration" class="dea-documents">
    <div class="dea-documents__section-start">
      <Buttons
        v-for="document in registration.post_event_documents"
        :key="`document-${document.id}-${document.full_url}`"
        :href="document.full_url"
        type="a"
        target="_blank"
        class="dea-documents__buttons dea-button--medium dea-button--outline dea-button--iconLeft"
        icon="download"
        >{{ document.description }}</Buttons
      >
    </div>
    <div class="dea-documents__section-start">
      <template v-if="hasProgramDocument !== undefined">
        <div class="dea-heading--medium__xs dea-uppercase dea-documents__sections">plenaria</div>
        <template v-for="program in registration.linked_event.program">
          <div :key="`program-${program.id}`" class="dea-documents__sections-subtitle">
            <span class="dea-heading--medium__s">{{ program.title }}</span>
            <template v-if="program.speakers">
              <span
                v-for="speaker in program.speakers"
                :key="`speaker-${speaker.id}-program-${program.id}`"
                class="dea-documents__speakers dea-links--color-magenta-formazione"
                >{{ speaker.fullname }}</span
              >
            </template>
          </div>
          <Buttons
            v-for="document in program.documents"
            :key="`program-${program.id}-document-${document.full_url}`"
            :href="document.full_url"
            type="a"
            target="_blank"
            class="dea-documents__buttons dea-button--medium dea-button--outline dea-button--iconLeft"
            icon="download"
            >{{ document.description }}</Buttons
          >
        </template>
      </template>
    </div>
    <template v-if="hasSessionDocument !== undefined">
      <template v-for="session in registration.linked_event.sessions">
        <div :key="`session-${session.id}`" class="dea-documents__section-start">
          <div class="dea-heading--medium__xs dea-uppercase dea-documents__sections">{{ session.title }}</div>
          <template v-for="lab in session.labs">
            <div v-if="!lab.empty" :key="`lab-${lab.id}`" class="dea-documents__sections-subtitle">
              <span class="dea-heading--medium__s">{{ lab.title }}</span>
              <span
                v-if="lab.speakers_list"
                class="dea-documents__speakers dea-heading--regular__xm dea-links--color-magenta-formazione"
                >{{ lab.speakers_list }}</span
              >
            </div>
            <!-- we don't need a filter on buttons as empty labs don't have docs -->
            <Buttons
              v-for="document in lab.documents"
              :key="`lab-${lab.id}-document-${document.full_url}`"
              :href="document.full_url"
              type="a"
              target="_blank"
              class="dea-documents__buttons dea-button--medium dea-button--outline dea-button--iconLeft"
              icon="download"
              >{{ document.description }}</Buttons
            >
          </template>
        </div>
      </template>
    </template>
  </div>
  <Loader v-else></Loader>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import Loader from "@/components/elements/Loader";

export default {
  name: "DownloadMaterial",
  components: {
    Buttons,
    Loader,
  },
  props: {
    registration: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    hasProgramDocument() {
      const { program } = this.registration.linked_event;
      return program.find(element => {
        return element.documents.length;
      });
    },
    hasSessionDocument() {
      const session = this.registration.linked_event.sessions;
      return session.find(element => {
        return element.labs.find(lab => {
          return lab.documents.length;
        });
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.dea-uppercase {
  text-transform: uppercase;
}

.dea-documents {
  &__sections {
    margin-bottom: $space-base;
  }

  &__section-start .dea-button {
    margin-bottom: $space-base;
  }

  &__section-start + .dea-documents__section-start {
    margin-bottom: $space-large;
  }

  &__sections-subtitle {
    margin-bottom: $space-x-small;
    margin-top: $space-base;
  }

  &__buttons {
    display: inline-block;
    margin-right: $space-small;
  }

  &__buttons-inline {
    display: inline-block;
  }

  &__speakers {
    margin-left: $space-small;
  }
}
</style>
